import React, { useEffect } from 'react';
import { Router, Location, Redirect,Link,useNavigate } from 'react-router-dom';
import LogoX from './../../assets/icons/gumla.png';
import Waiter from './../../assets/gif/blueCircle.gif';
import { createGlobalStyle } from 'styled-components';
import {URLPREFIX,API_CORE_SERVER,RS_LABEL,DDMMYYYY_LABEL} from './../../constants';
const JComponent= () => {
	const navigate=useNavigate();
	
  return(
    <>
	<div className='container'>
		<nav className="navbar navbar-expand-lg navbar-light private">
		  <div className="container-fluid">
			<a className="navbar-brand" href="#">
				<img src={LogoX} className='logo-sm' />
			</a>
			<span>
				<span className='fs-5 fw-bolder'>Gram Sampati, Ramgarh</span>
				<br/>
				<center className='fs-7'>  Digital Asset Register</center>
			</span>
			<button className="navbar-toggler shadow rounded-circle px-3 py-3" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
			  <i className="bi bi-three-dots-vertical"></i>
			</button>
			<div className="collapse navbar-collapse justify-content-end" id="navbarNavDropdown">
			  <ul className="navbar-nav">
			  <li className="nav-item">
				  <a className="nav-link" aria-current="page" href="https://ramgarhgramsampati.in/public">Public Dashboard</a>
				</li>
				<li className="nav-item">
				  <Link className="nav-link" aria-current="page" to={URLPREFIX+"/"}>Login</Link>
				</li>
			  </ul>
			</div>
		  </div>
		</nav>
	</div>
	</>
	);
};
export default JComponent;